import { debitNote as debitNoteEn } from '../en/debitNote';

export const debitNote = {
  ...debitNoteEn,
  debitNotes: 'ණය සටහන්',
  allDebitNotes: 'සියලුම ණය සටහන්',
  createDebitNote: 'ණය සටහනක් නිකුත් කරන්න',
  debitNoteDetails: 'ණය සටහනේ විස්තර',
  status_issued: 'නිකුත් කරන ලදී',
  status_applied: 'යොදන ලදී',
  status_cancelled: 'අවලංගු කරන ලදී',

  // Apply to a purchase order of the same supplier
  applyAmountExceedsPurchaseOrderBalance: 'මුදල තෝරාගත් මිලදී ගැනීමේ ඇණවුමේ ගෙවිය යුතු ශේෂය ඉක්මවයි',
  viewAndManageAllDebitNotes: "සියලුම ණය සටහන් බලන්න සහ කළමනාකරණය කරන්න",
  createDebitNoteDescription: "සැපයුම්කරුගේ මිලදී ගැනීමේ ඇණවුමකට එරෙහිව ණය සටහනක් අතින් නිකුත් කරන්න",
  debitNoteNumber: "ණය සටහන් අංකය",
  supplier: "සැපයුම්කරු",
  purchaseOrderNumber: "මිලදී ගැනීමේ ඇණවුම",
  purchaseOrderBalance: "ඇණවුමේ ශේෂය",
  sourceType: "මූලාශ්‍රය",
  amount: "මුදල",
  appliedAmount: "යොදන ලද මුදල",
  remainingAmount: "ඉතිරි මුදල",
  status: "තත්ත්වය",
  createdAt: "සාදන ලද දිනය",
  actions: "ක්‍රියා",
  debitNoteDetailsTitle: "ණය සටහනේ විස්තර",
  offsetPayments: "හිලව් ගෙවීම්",
  sourceReturnToVendor: "මූලාශ්‍ර ආපසු යැවීම",
  sourceType_return_to_vendor: "සැපයුම්කරුට ආපසු යැවීම",
  sourceType_price_adjustment: "මිල ගැලපීම",
  sourceType_correction: "නිවැරදි කිරීම",
  selectSupplier: "සැපයුම්කරු තෝරන්න",
  allSuppliers: "සියලුම සැපයුම්කරුවන්",
  purchaseOrder: "මිලදී ගැනීමේ ඇණවුම",
  selectPurchaseOrder: "මිලදී ගැනීමේ ඇණවුම තෝරන්න",
  purchaseOrderIdPlaceholder: "මිලදී ගැනීමේ ඇණවුම් ID ඇතුළත් කරන්න",
  amountPlaceholder: "මුදල ඇතුළත් කරන්න",
  reason: "හේතුව",
  reasonPlaceholder: "මෙම ණය සටහන නිකුත් කිරීමට හේතුව...",
  applyAmountLabel: "යෙදිය යුතු මුදල",
  create: "ණය සටහන නිකුත් කරන්න",
  applyDebitNote: "ණය සටහන යොදන්න",
  cancelDebitNote: "ණය සටහන අවලංගු කරන්න",
  print: "මුද්‍රණය කරන්න",
  printDebitNote: "ණය සටහන මුද්‍රණය කරන්න",
  backToDebitNotes: "ණය සටහන් වෙත ආපසු",
  confirmCancelDebitNote: "මෙම ණය සටහන අවලංගු කිරීමට ඔබට විශ්වාසද?",
  filterBySupplier: "සැපයුම්කරු අනුව පෙරහන් කරන්න",
  filterByPurchaseOrder: "මිලදී ගැනීමේ ඇණවුම අනුව පෙරහන් කරන්න",
  debitNoteCreatedSuccessfully: "ණය සටහන {number} සාර්ථකව නිකුත් කරන ලදී",
  debitNoteAppliedSuccessfully: "ණය සටහන සාර්ථකව යොදන ලදී",
  debitNoteCancelledSuccessfully: "ණය සටහන සාර්ථකව අවලංගු කරන ලදී",
  failedToCreateDebitNote: "ණය සටහන නිකුත් කිරීමට අසමත් විය",
  failedToLoadDebitNotes: "ණය සටහන් පූරණය කිරීමට අසමත් විය",
  failedToLoadDebitNote: "ණය සටහන පූරණය කිරීමට අසමත් විය",
  failedToApplyDebitNote: "ණය සටහන යෙදීමට අසමත් විය",
  failedToCancelDebitNote: "ණය සටහන අවලංගු කිරීමට අසමත් විය",
  someFieldsRequired: "ඉදිරිපත් කිරීමට පෙර ඉස්මතු කළ ක්ෂේත්‍ර නිවැරදි කරන්න",
  supplierRequired: "කරුණාකර සැපයුම්කරුවෙකු තෝරන්න",
  purchaseOrderRequired: "කරුණාකර මිලදී ගැනීමේ ඇණවුමක් තෝරන්න",
  amountMustBePositive: "මුදල ශුන්‍යයට වඩා වැඩි විය යුතුය",
  applyAmountExceedsRemaining: "යොදන මුදල ඉතිරි ශේෂය ඉක්මවිය නොහැක",
  reasonRequired: "කරුණාකර හේතුවක් ඇතුළත් කරන්න",
  noDebitNotesFound: "ණය සටහන් හමු නොවීය",
  noDebitNotesYet: "තවමත් ණය සටහන් නැත.",
  noDebitNotesFoundDescription: "ඔබගේ වත්මන් පෙරහන්වලට ගැළපෙන ණය සටහන් නැත",
  noDebitNotesYetDescription: "මිලදී ගැනීමේ ඇණවුමකට එරෙහිව සැපයුම්කරු බැර කිරීමක් සටහන් කිරීමට ඔබගේ පළමු ණය සටහන නිකුත් කරන්න.",
  issueFirstDebitNote: "පළමු ණය සටහන නිකුත් කරන්න",
};
